import React, { useState } from "react";
import "./FriendActionModal.css";
import { useDispatch, useSelector } from "react-redux";
import {
  setShowReportPopup,
  resetFriendModalState,
} from "../../redux/slicers/friendModalSlicer";
import * as reportApi from "../../api/requests/report";

const ReportPopup = () => {
  const dispatch = useDispatch();
  const { showReportPopup, selectedFriend, selectedPost } = useSelector(
    (state) => state.friendModal
  );

  const [selectedReason, setSelectedReason] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!selectedFriend?.username) {
      setError("No user selected to report");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await reportApi.createReport(
        selectedFriend.username,
        selectedReason,
        "", // additionalInfo
        selectedPost?._id // postId
      );

      if (response?.status === 201) {
        setSubmitted(true);
        setLoading(false);
        setTimeout(() => {
          setSubmitted(false);
          setSelectedReason("");
          setError("");
          dispatch(resetFriendModalState());
        }, 3000);
      } else {
        setError(response?.data?.errors?.[0]?.msg || "Failed to submit report");
        setLoading(false);
      }
    } catch (err) {
      console.error("Error submitting report:", err);
      setError("An error occurred while submitting the report");
      setLoading(false);
    }
  };
  const handleCancel = () => {
    setSelectedReason("");
    setSubmitted(false);
    setError("");
    dispatch(resetFriendModalState());
  };

  if (!showReportPopup) return null;

  return (
    <div className="report-popup">
      <div className="report-popup__content">
        {!submitted ? (
          <>
            <h3>Why are you reporting this user?</h3>
            <p>
              If someone is in immediate danger, get help before reporting to
              LoonLog. Don't wait.
            </p>
            {error && (
              <div
                style={{ color: "red", marginBottom: "10px", fontSize: "14px" }}
              >
                {error}
              </div>
            )}
            <div className="report-reasons">
              {[
                "Problem involving someone under 18",
                "Bullying, harassment or abuse",
                "Suicide or self-harm",
                "Violent, hateful or disturbing content",
                "Selling or promoting restricted items",
                "Adult content",
                "Scam, fraud or false information",
                "Intellectual property",
                "I don’t want to see this",
              ].map((reason, index) => (
                <label key={index} className="report-option">
                  <input
                    type="radio"
                    name="reportReason"
                    value={reason}
                    checked={selectedReason === reason}
                    onChange={(e) => setSelectedReason(e.target.value)}
                  />
                  {reason}
                </label>
              ))}
            </div>
            <div className="flex">
              <button
                className="follow-btn"
                disabled={!selectedReason || loading}
                onClick={handleSubmit}
              >
                {loading ? "Submitting..." : "Report / Flag"}
              </button>
              <button
                className="follow-btn"
                onClick={handleCancel}
                disabled={loading}
              >
                Cancel
              </button>
            </div>
          </>
        ) : (
          <>
            <h3>Thanks for your report.</h3>
            <p>
              Our team will review this post to ensure it follows our community
              guidelines. If it violates our rules, appropriate action will be
              taken.
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default ReportPopup;

